import type { CardShapes } from './types';

export const CARD_SHAPES = {
  circle: 'circle',
  square: 'square',
  smallSquare: 'small-square',
  rectangle: 'rectangle',
} as const;

export const CARD_LIST_GAP = 8;

type CardConfig = Record<CardShapes, number>;

export const CARD_WIDTH_MAP: CardConfig = {
  [CARD_SHAPES.circle]: 72,
  [CARD_SHAPES.square]: 90,
  [CARD_SHAPES.smallSquare]: 70,
  [CARD_SHAPES.rectangle]: 90,
};

export const ICON_HEIGHT_MAP: CardConfig = {
  [CARD_SHAPES.circle]: 72,
  [CARD_SHAPES.square]: 72,
  [CARD_SHAPES.smallSquare]: 60,
  [CARD_SHAPES.rectangle]: 44,
};

export const FALLBACK_ICON_SIZE_MAP: CardConfig = {
  [CARD_SHAPES.circle]: 40,
  [CARD_SHAPES.square]: 40,
  [CARD_SHAPES.smallSquare]: 35,
  [CARD_SHAPES.rectangle]: 24,
};
